import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doc1",
  "use": "icon-doc1-usage",
  "viewBox": "0 0 300 300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 300 300\" overflow=\"visible\" id=\"icon-doc1\">\r\n<path d=\"M154.48,138.06c-1.79,0-4.18-0.6-5.97-1.19c-4.18-2.39-7.16-6.57-7.16-11.34V52.09\r\n\tc0-7.76,5.97-13.73,13.73-13.73h40.6c7.76,0,13.73,5.97,13.73,13.73v72.83c0,4.78-2.98,9.55-7.16,11.34\r\n\tc-4.18,2.39-9.55,1.79-13.73-1.19l-13.13-9.55l-13.13,9.55C159.85,136.86,156.87,138.06,154.48,138.06L154.48,138.06z M159.25,56.27\r\n\tv59.1l8.36-5.97c4.78-3.58,10.75-3.58,15.52,0l8.36,5.97v-59.1H159.25z M159.25,56.27\" />\r\n<path d=\"M202.84,263.43H94.18c-24.48,0-44.18-19.7-44.18-44.18V80.75c0-24.48,19.7-44.18,44.18-44.18h111.64\r\n\tc24.48,0,44.18,19.7,44.18,44.18v135.52C250,242.54,229.1,263.43,202.84,263.43L202.84,263.43z M94.18,54.48\r\n\tc-14.33,0-26.27,11.94-26.27,26.27v138.51c0,14.33,11.94,26.27,26.27,26.27h108.66c16.12,0,29.25-13.13,29.25-29.25V80.75\r\n\tc0-14.33-11.94-26.27-26.27-26.27H94.18z M94.18,54.48\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/doc1.svg
// module id = 7rKs
// module chunks = 34